import React from "react";
import { FaWrench, FaBolt, FaCheckCircle, FaGraduationCap } from "react-icons/fa";

const CoursesFullWidthNoGaps = () => {
  const courses = [
    {
      title: "FITTER",
      duration: "2 Years",
      icon: <FaWrench className="h-10 w-10 text-green-600" />,
      color: "green",
      bgGradient: "from-green-50 to-green-100",
      keywords: ["Hands-on Training", "Machine Tools", "Precision Measuring", "Workshop Practice"],
      description:
        "On completion of the course he shall be able to independently prepare machine components, using skills such as filling, hack sawing, drilling chipping, reaming, screw cutting and scrapping, individually handle precision measuring instruments and read machine drawing also handle various fitter tools and operate different machine such as drilling machines etc.",
      highlights: [
        "Precision fitting & assembly",
        "Lathe & drilling machine operation",
        "Reading engineering drawings",
        "Use of measuring instruments (vernier, micrometer)",
      ],
    },
    {
      title: "ELECTRICIAN",
      duration: "2 Years",
      icon: <FaBolt className="h-10 w-10 text-orange-500" />,
      color: "orange",
      bgGradient: "from-orange-50 to-orange-100",
      keywords: ["Electrical Systems", "Wiring", "Substation", "Motor Control"],
      description:
        "SKILLED ACQUIRED: - On completion of course the trainee shall have through knowledge of generation, transmission and distribution line, overhead different types of insulators. Earning used in substation, power station, lighting arrestor, reactor and different types of capacitors in AC/DC circuit used in electronic and electrical installation in industries etc.",
      highlights: [
        "Generation & transmission systems",
        "Substation & switchgear",
        "AC/DC circuits & capacitors",
        "Industrial electrical installations",
      ],
    },
  ];

  return (
    <section className="w-full bg-gradient-to-br from-green-50 via-white to-orange-50 py-16 md:py-24">
      <div className="w-full px-0">
        <div className="mx-auto mb-12 max-w-4xl px-4 text-center sm:px-6 lg:px-8">
          <div className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 shadow-md">
            <FaGraduationCap className="h-5 w-5 text-green-600" />
            <span className="text-sm font-semibold text-gray-700">NSQF Aligned | Govt. Approved</span>
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900 md:text-4xl">
            Build Your Future with <span className="text-green-600">Industry‑Ready</span>{" "}
            <span className="text-orange-500">Skills</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-gray-600">
            Choose from our specialized trades – designed to give you hands‑on experience and
            a competitive edge in the job market.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2">
          {courses.map((course, idx) => (
            <div
              key={idx}
              className={`flex h-full flex-col bg-gradient-to-br ${course.bgGradient} p-6 shadow-xl transition-all hover:shadow-2xl md:p-8`}
            >
              <div className="mb-4 flex items-center gap-3">
                <div className="rounded-full bg-white p-3 shadow-md">
                  {course.icon}
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 md:text-3xl">
                    {course.title}
                  </h3>
                  <p className="text-sm font-medium text-gray-500">
                    Duration: {course.duration}
                  </p>
                </div>
              </div>
              <div className="mt-2 flex flex-wrap gap-2">
                {course.keywords.map((kw, i) => (
                  <span
                    key={i}
                    className={`rounded-full bg-${course.color}-100 px-3 py-1 text-xs font-semibold text-${course.color}-800`}
                  >
                    {kw}
                  </span>
                ))}
              </div>
              <p className="mt-4 text-gray-700 leading-relaxed">{course.description}</p>
              <div className="mt-6">
                <h4 className="mb-3 text-lg font-semibold text-gray-800">
                  Key Skills Acquired:
                </h4>
                <ul className="grid grid-cols-1 gap-2">
                  {course.highlights.map((item, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <FaCheckCircle className={`mt-1 h-4 w-4 text-${course.color}-600 flex-shrink-0`} />
                      <span className="text-sm text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-8">
                <button
                  className={`group inline-flex items-center gap-2 rounded-full border border-${course.color}-200 bg-white px-6 py-2.5 font-semibold text-${course.color}-700 shadow-sm transition-all hover:border-${course.color}-300 hover:bg-${course.color}-50 hover:shadow-md`}
                >
                  Read More
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 transition-transform group-hover:translate-x-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoursesFullWidthNoGaps;